// extracted by mini-css-extract-plugin
export default {"settingsContainer":"SettingsBar_settingsContainer__G5V7m","formSelect":"SettingsBar_formSelect__jZIwo","btn":"SettingsBar_btn__nVWEU","spacer":"SettingsBar_spacer__7LAxd"};